/**
 *
 * TenantView
 *
 */

import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import React from 'react';

function TenantView({
    dataTable,
    viewName,
    viewStyles,
    formDialog,
}) {
    return (
        <div style={viewStyles.root}>
            {<Paper style={viewStyles.dataTable}>
                {
                    React.cloneElement(dataTable, { viewName })
                }
            </Paper>
            }
            {React.cloneElement(formDialog, { viewName })}
        </div>
    );
}

TenantView.propTypes = {
    dataTable: PropTypes.node.isRequired,
    viewName: PropTypes.string.isRequired,
    viewStyles: PropTypes.object,
};

TenantView.defaultProps = {
    viewStyles: {},
};

export default TenantView;
